<template>
  <div class="panel panel-default">
    <!-- Default panel contents -->
    <div class="panel-heading text-center">
      <h5 style="display: inline-block">{{ title }}</h5>
      <button class="btn btn-warning btn-sm pull-right export-button" style="display: inline;"
              data-toggle="tooltip"
              data-placement="top"
              title="Export this chart's data as CSV"
              v-if="this.$store.state.stats.length > 0"
              @click.stop="exportCSV(reportName)">
        <i class="fas fa-download"></i>
      </button>
    </div>

    <div class="panel-body">
      <!-- Error message -->
      <p class="text-center text-danger" v-if="errorBag.message">
        <i class="fas fa-exclamation-triangle"></i>
        <small>
          <strong>{{ errorBag.message }}</strong>
        </small>
      </p>
      <!-- Error message -->

      <div class="row">
        <div class="col-md-4 col-sm-4 col-xs-12">
          <span># of records</span>
          <input class="form-control input-sm" type="number" v-model="number" placeholder="Number of records">
        </div>
        <div class="col-md-4 col-sm-4 col-xs-12">
          <span>Filter</span>
          <select class="form-control input-sm" v-model="activeFilter">
              <option v-for="filter in filterList" :key="filter.title" :value="filter.propName">{{ filter.title }}</option>
          </select>
        </div>
        <div class="col-md-4 col-sm-4 col-xs-12">
          <span>Sort Order</span>
          <select class="form-control input-sm" v-model="sortOrder">
              <option value="asc">Low to High</option>
              <option value="desc">High to Low</option>
          </select>
        </div>
      </div>
    </div>

    <!-- List group -->
    <ul class="list-group">

      <li class="list-group-item" v-for="stat in filteredStats" :key="`${stat.UserId}_${stat.CohortId}`">

        <div class="list-group-item-heading text-left">
          <a class="btn btn-xs btn-transparent" role="button" :href="emailUrl(stat.Email)" target="_blank">
            <i class="fas fa-envelope"></i>
          </a>&nbsp;
          {{ stat.UserFullName }}
          <span class="badge pull-right">{{ stat[activeFilter] }}<span v-if="activeFilter === 'ProgressPercent'">%</span></span>
        </div>

      </li>

    </ul>

    <!-- <div class="panel-footer">
      <div class="text-muted text-center">
        <i class="fas fa-info-circle"></i>
        <small>{{ info }}</small>
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'list-group',

  props: ['title', 'info'],

  data () {
    return {
      activeFilter: '',
      filterList: [
        { title: 'By Progress', propName: 'ProgressPercent' },
        { title: 'By FeedbackScore', propName: 'FeedbackScore' },
        { title: 'By DiscussionPosts', propName: 'DiscussionPosts' }
      ],
      number: 5,
      sortOrder: 'desc',
      errorBag: {}
    }
  },

  computed: {
    filteredStats () {
      if (this.sortOrder === 'desc') {
        // eslint-disable-next-line
        return _.reverse(this.$store.getters.topBy(this.activeFilter, this.number))
      } else {
        return this.$store.getters.topBy(this.activeFilter, this.number)
      }
    },

    reportName () {
      // eslint-disable-next-line
      return 'leaderboard'
    }
  },

  beforeDestroy () {
    this.eventHub.$off('gccFilterUpdated')
  },

  mounted () {
    /** Listen for when Progress Buckets are updated */
    this.eventHub.$on('gccFilterUpdated', this.refresh)
    this.activeFilter = 'ProgressPercent'
  },

  methods: {
    errorCheck () {
      // eslint-disable-next-line
      if (_.isEqual(this.$store.state.selectedGroup, {}) || (this.$store.state.selectedGroupCourses.length === 0)) {
        this.errorBag.status = 'danger'
        this.errorBag.message = 'Please select at least 1 Group and 1 Course'
      } else if (this.activeFilter === '') {
        this.errorBag.status = 'danger'
        this.errorBag.message = 'Please select a Course from this dropdown.'
      } else {
        this.errorBag.status = ''
        this.errorBag.message = ''
      }
    },

    refresh () {
      this.errorCheck()
      this.$forceUpdate()
    },

    emailUrl (email) {
      return `mailto:${email}`
    },

    exportCSV (reportName) {
      this.eventHub.$emit('exportCSV', reportName)
    }
  }
}
</script>

<style lang="scss" scoped>
  .btn.btn-transparent {
    background-color: transparent;
    border-color: transparent;
    padding: 0;
    color: #ccc;
    transition: all 100ms ease-in-out;
  }

  a.btn.btn-transparent:focus,
  a.btn.btn-transparent:hover,
  a.btn.btn-transparent:active {
    background-color: transparent;
    color: #FF6800;
  }

  .panel.panel-default {
    background-color: transparent !important;
    border: none !important;

    .panel-heading {
      background-color: #fafafa !important;
      border: none !important;
    }

    .list-group {
      overflow-y: scroll;
      max-height: 155px;
      .list-group-item {
        padding: 5px 1em 0 1em !important;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/ListGroup.vue